import PropTypes from 'prop-types'

import Poly from '@s-ui/react-primitive-polymorphic-element'

import {BASE_CLASS} from '../config.js'

export function Title({as = 'h3', children, ...props}) {
  return (
    <Poly as={as} className={`${BASE_CLASS}-title`} {...props}>
      {children}
    </Poly>
  )
}

Title.propTypes = {
  as: PropTypes.string,
  children: PropTypes.node.isRequired
}
